<template>
    <div class="pill" :class="[color]">
        <slot />
    </div>
</template>

<script lang="ts" setup>
type ColorOption = 'green'

const props = withDefaults(
    defineProps<{
        color?: ColorOption
    }>(),
    { color: 'green' }
)
</script>

<style scoped lang="scss">
@import '@/assets/css/theme.scss';
@import '@/assets/css/variables.scss';

.pill {
    @include br-999;
    @include items-center;
    @include justify-center;
    @include inline-flex;
    @include opteo-white;
    @include f-9;
    @include fw-500;
    letter-spacing: -0.0075rem;
    height: 2.25rem;
    @include ph-16;
    @include pv-12;
}

.pill.green {
    background: $opteo-dark-green-translucent;
    color: $opteo-dark-green;
    @include br-999;
}
</style>
